<div class="dialog-button">
  {{ displayValue() | translate }}
</div>
